import { onUnmounted, readonly, ref, watch } from 'vue'
import type { Ref } from 'vue'

/**
 * Relógio da tela em "hora do servidor" — a versão genérica de `usePrioritySlaTick`. O
 * desvio `serverNow − Date.now()` é medido a cada resposta e aplicado a cada tique: um
 * navegador com o relógio errado não pode fazer um item parecer no prazo quando o
 * servidor já o conta como vencido. Um tique só por tela; os cards recebem `nowMs` por prop.
 */
export function useServerNowTick(
  serverNow: () => string | null,
  tickMs = 60_000
): { nowMs: Readonly<Ref<number | null>> } {
  const nowMs = ref<number | null>(null)
  let offsetMs: number | null = null

  const update = (): void => {
    nowMs.value = offsetMs === null ? null : Date.now() + offsetMs
  }

  watch(
    serverNow,
    (value) => {
      const parsed = value ? Date.parse(value) : Number.NaN
      offsetMs = Number.isFinite(parsed) ? parsed - Date.now() : null
      update()
    },
    { immediate: true }
  )

  const timer = setInterval(update, tickMs)
  onUnmounted(() => clearInterval(timer))

  return { nowMs: readonly(nowMs) }
}
